import { capitalize } from 'src/utilities/string-utils';

export function getBrandFeatureName(brand: string): string {
  return `${capitalize(brand.toLowerCase())}+`;
}
